dealershipModule.controller('DealerProfileController',
    ['$scope','$rootScope', '$q', 'dealerProfileService', 'DealerProfile', 'dealershipModuleConstants','TLCError','AppErrorCodes',
        function ($scope, $rootScope, $q, dealerProfileService, DealerProfile, dealershipModuleConstants,TLCError,AppErrorCodes) {
              // passed in via directive attributes: $scope.product

            $scope.dealerProfile = new DealerProfile();
            $scope.originalDealerProductProfile = new DealerProfile();
            $scope.loading = false;
            $scope.profitSettings_complete = false;

            makeModelClean();

            $scope.init = function() {
                $scope.loading = true;

                dealerProfileService.getDealerProductProfile($scope.product.productCode.replace('/', ''), Date.today())
                    .then(
                        function (responseData) {
                            $scope.dealerProfile = responseData;
                            $scope.originalDealerProductProfile = angular.copy($scope.dealerProfile);
                        },
                        function (err) {
                            throw new TLCError(new Error("There was an error retrieving the dealer product profile:  " + err), AppErrorCodes.DealerProductProfileController_GeneralError);
                        })
                    .finally(
                        function () {
                            $scope.loading = false;
                        });
            };

            // Persists dealer product profile
            $scope.saveDealerProductProfile = function() {
                if ($scope.promiseSave) {
                    $scope.promiseSave.resolve();
                };

                if (angular.equals($scope.dealerProfile, $scope.originalDealerProductProfile)) {
                    return;
                }

                dealerProfileService.updateDealerProductProfile(Date.today(), $scope.dealerProfile)
                    .then(function(data) {
                            makeModelClean();
                            $rootScope.$broadcast(dealershipModuleConstants.RERATE_PRODUCT, {productId: $scope.product.productCode});
                        },
                        function(error) {
                            makeModelClean();
                        });
            };

            $scope.cancelEdit = function() {
                makeModelClean();
            };


            function makeModelClean() {
                $scope.dealerProfile = new DealerProfile();
                $scope.originalDealerProductProfile = new DealerProfile();

            }

            $scope.$on('productSettingsSave', function(e) {
                $scope.saveDealerProductProfile();
            });

            $scope.$on('productSettingsCancel', function(e) {
                $scope.cancelEdit();
            });

            $scope.$on('profitSettingsComplete', function(e) {
                $scope.profitSettings_complete = true;
                $scope.init();
            });


            $scope.init();
        }
    ]);